module.exports = __webpack_public_path__ + "img/wisetokenswitzerland.973085ed.png";